import styled from 'styled-components'

const ConversationListEmptyTitle = styled.div`
	font-size: 20px;
	font-weight: bold;
	text-align: center;
`

export default ConversationListEmptyTitle